// src/components/HowToPlay.jsx
import React from "react";
import "./HowToPlay.css";

const HowToPlay = ({ onClose }) => {
  return (
    <div className="how-to-play-overlay">
      <div className="how-to-play-container">
        
        {/* This header cleanly groups the title and close button */}
        <div className="modal-header">
          <h2>How to Play</h2>
          <button className="close-button" onClick={onClose} aria-label="Close modal">
            &times;
          </button>
        </div>

        <ul>
          <li>
            🚗 Tap the <strong>left half</strong> of the screen to switch the{" "}
            <strong>Red Car</strong> between its lanes.
          </li>
          <li>
            🚙 Tap the <strong>right half</strong> of the screen to switch the{" "}
            <strong>Blue Car</strong> between its lanes.
          </li>
          <li>
            ⚪ Collect <strong>circle-shaped</strong> objects to score points.
          </li>
          <li>
            ⬛ Avoid collecting <strong>square-shaped</strong> objects — collecting them might end the game.
          </li>
          <li>
            ⛔ Don't miss any circle-shaped objects — missing one might end the game.
          </li>
        </ul>
        
        {/* Added a specific class to prevent style conflicts with the close button */}
        <button className="got-it-button" onClick={onClose}>Got it!</button>

      </div>
    </div>
  );
};

export default HowToPlay;